var jquery = require("jquery");
window.$ = window.jQuery = jquery;
require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;
import Lenis from 'lenis';
import './maps';

// Initialize Lenis
const lenis = new Lenis({
	lerp: 0.05, 
	wheelMultiplier: 1.5,
});

let header = $('header');
let lastScrollTop = 0;
const delta = 0.5;
var navbarHeight = $('.headerContainer').outerHeight();


// OVERRIDE DEFAULT HASH SCROLL
let hashScrolled = false;
let pendingHash = null;

// Immediately prevent default hash scroll on page load (runs before DOM is ready)
(function() {
	if (window.location.hash) {
		pendingHash = window.location.hash;
		// Remove hash from URL immediately to prevent browser scroll
		history.replaceState(null, null, window.location.pathname + window.location.search);
		// Force scroll to top to prevent any browser-initiated scroll
		window.scrollTo(0, 0);
		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;
	}
})();

function scrollToHash(offset = 20) {
	const hash = window.location.hash || pendingHash;
	if (!hash || hash.length <= 1) return;
	
	const targetId = hash.substring(1);
	const targetElement = document.getElementById(targetId) || document.querySelector(`[id="${targetId}"]`);
	
	if (targetElement) {
		// Ensure Lenis is initialized
		if (!lenis) {
			setTimeout(() => scrollToHash(offset), 50);
			return;
		}
		
		// Wait a frame to ensure layout is stable
		requestAnimationFrame(() => {
			// Recalculate navbar height in case it changed
			const rect = targetElement.getBoundingClientRect();
			const scrollY = window.pageYOffset || document.documentElement.scrollTop;
			// Reduce offset to scroll less (smaller offset = less space from top)
			const targetPosition = rect.top + scrollY - offset;
			
			lenis.scrollTo(targetPosition, {
				duration: 1,
				offset: 0
			});
			
			hashScrolled = true;
			pendingHash = null;
		});
	}
}

/**
 * Same-page anchor navigation for Lenis: avoid relying on hashchange (same hash = no event)
 * and avoid native scroll fighting lenis.scrollTo.
 */
function navigateInPageOrAssign(url, newTab) {
	if (!url) return;
	if (newTab) {
		window.open(url, '_blank', 'noopener,noreferrer');
		return;
	}
	const trimmed = String(url).trim();
	let fragment = null;
	if (trimmed.startsWith('#') && trimmed.length > 1) {
		fragment = trimmed;
	} else {
		try {
			const resolved = new URL(trimmed, window.location.href);
			if (
				resolved.origin === window.location.origin &&
				resolved.pathname === window.location.pathname &&
				resolved.search === window.location.search &&
				resolved.hash.length > 1
			) {
				fragment = resolved.hash;
			}
		} catch (_) {
			// fall through to assign
		}
	}
	if (fragment) {
		hashScrolled = true;
		pendingHash = fragment;
		history.pushState(null, '', window.location.pathname + window.location.search + fragment);
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				scrollToHash(20);
			});
		});
		return;
	}
	window.location.assign(trimmed);
}

// Handle hash scroll after page is fully loaded
function handleHashScroll() {
	if (pendingHash || window.location.hash) {
		if (pendingHash) {
			window.location.hash = pendingHash;
		}
		
		// Wait for dynamic content (like Google Reviews widget) to load before scrolling
		setTimeout(() => {
			scrollToHash(20); // Adjust this value: larger = scrolls further down, less previous section visible
		}, 1250); // 2 second delay to allow widgets and dynamic content to load
	}
}

$(function() {
	// Handle hash scroll after DOM is ready
	if (pendingHash || window.location.hash) {
		if (document.readyState === 'complete') {
			handleHashScroll();
		} else {
			$(window).on('load', function() {
				handleHashScroll();
			});
		}
	}
});

$(window).on('hashchange', function() {
	if (!hashScrolled && !pendingHash) {
		setTimeout(() => {
			scrollToHash(20); // Adjust this value: larger = scrolls further down, less previous section visible
		}, 100);
	}
	hashScrolled = false;
});

$(document).on('click', 'a[href^="#"]', function(e) {
	const href = $(this).attr('href');
	if (href !== '#' && href.length > 1) {
		e.preventDefault();
		navigateInPageOrAssign(href, false);
	}
});

lenis.on('scroll', (e) => {

    const st = e.scroll;


    // Ensure scroll has surpassed delta value before proceeding
    if (Math.abs(lastScrollTop - st) > delta) {

		// Check scroll direction and update header classes
		if (st > lastScrollTop && st > navbarHeight) {
			// Scrolled down
			if (header.hasClass('nav-down')) {
				header.removeClass('nav-down').addClass('nav-up');
				// if ($('body.offset').length) {
				// 	header.closest('section').attr('data-bg','secondary-one');
				// }
			}
		} else {
			// Scrolled up
			if (st > navbarHeight && (st + $(window).height() < $(document).height())) {
				header.removeClass('nav-up').addClass('nav-down');
				// header.closest('section').attr('data-bg','secondary-four');
			}

			if (st < 10) {
				header.removeClass('nav-up nav-down');
				// if ($('body.offset').length) {
					// header.closest('section').attr('data-bg','secondary-one');
				// }
			}
		}
	}

    // Update last scroll position
    lastScrollTop = st;

	checkLogoColor();

});

// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}


import ScrollOut from "scroll-out";

ScrollOut({
	cssProps: {
		viewportY: true,
	},
});




// READY

$(function () {

	console.log('Website proudly by Imagic Creative');

	requestAnimationFrame(raf);

	if ($('section[data-section="sliderType1"]').length) {
		setInterval(() => {
			var widgetNote = $('section[data-section="sliderType1"]').find('.es-main-content + script + a')
			widgetNote.remove();
		}, 100);
	}


	// MENU

	const supportsHover = window.matchMedia('(hover: hover)').matches;

	if (supportsHover) {
		$('.block-item[data-submenu]').hover(
			function () {
				const submenu = $(this).find('.block-submenu');
				fadeUp(submenu);
				$(this).find('.submenu-toggle').attr('aria-hidden','false');
			},
			function () {
				const submenu = $(this).find('.block-submenu');
				fadeDown(submenu);
				$(this).find('.submenu-toggle').attr('aria-hidden','true');
			}
		);
	} else {
		$('.submenu-toggle').on('click', function (e) {
			e.preventDefault();
			const submenu = $(this).siblings('.block-submenu');
			if (submenu.is(':visible')) {
				fadeDown(submenu);
				$(this).attr('aria-hidden','true');
			} else {
				fadeUp(submenu);
				$(this).attr('aria-hidden','false');
			}
			$(this).toggleClass('open');
		});
	}
	
	// MOVE TEAM POPUPS
	$('aside.teamCards-popup').each(function() {
        $('main').append(this);
    });

	// Investment page floating CTA: slide in from right; dismiss fades out + slides right (no persistence)
	(function initFloatingCta() {
		const el = document.querySelector('[data-floating-cta]');
		if (!el) return;

		const closeBtn = el.querySelector('[data-floating-cta-close]');
		const overlay = el.querySelector('[data-floating-cta-overlay]');
		const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		const show = () => {
			if (prefersReducedMotion) {
				el.classList.add('floating-cta--visible');
				return;
			}
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					el.classList.add('floating-cta--visible');
				});
			});
		};

		show();

		let dismissing = false;

		/**
		 * @param {{ navigateUrl?: string, newTab?: boolean }} [opts]
		 */
		function dismiss(opts = {}) {
			if (dismissing) return;
			dismissing = true;

			const { navigateUrl = null, newTab = false } = opts;

			const go = () => {
				if (!navigateUrl) return;
				if (newTab) {
					window.open(navigateUrl, '_blank', 'noopener,noreferrer');
				} else {
					navigateInPageOrAssign(navigateUrl, false);
				}
			};

			if (prefersReducedMotion) {
				el.remove();
				go();
				return;
			}

			let done = false;
			function teardown() {
				if (done) return;
				done = true;
				el.removeEventListener('transitionend', onEnd);
				el.remove();
				go();
			}
			function onEnd(e) {
				if (e.target !== el) return;
				if (e.propertyName !== 'transform' && e.propertyName !== 'opacity') return;
				teardown();
			}
			el.addEventListener('transitionend', onEnd);
			window.setTimeout(teardown, 800);
			el.classList.remove('floating-cta--visible');
		}

		closeBtn?.addEventListener('click', () => dismiss());

		overlay?.addEventListener('click', (e) => {
			e.preventDefault();
			const url = overlay.getAttribute('href');
			if (!url) {
				dismiss();
				return;
			}
			const newTab = overlay.getAttribute('target') === '_blank';
			const trimmed = url.trim();
			let samePageAnchor = false;
			if (!newTab) {
				if (trimmed.startsWith('#') && trimmed.length > 1) {
					samePageAnchor = true;
				} else {
					try {
						const r = new URL(trimmed, window.location.href);
						samePageAnchor =
							r.origin === window.location.origin &&
							r.pathname === window.location.pathname &&
							r.search === window.location.search &&
							r.hash.length > 1;
					} catch (_) {
						// ignore
					}
				}
			}
			// Scroll immediately for in-page anchors; deferring to dismiss().go() waited on the exit animation and skipped scroll when hash was unchanged (no hashchange).
			if (samePageAnchor) {
				navigateInPageOrAssign(trimmed, false);
				dismiss();
				return;
			}
			dismiss({ navigateUrl: url, newTab });
		});
	})();

	// List type 2: mobile accordion — WAAPI max-height (CSS transitions often get overridden); fallback uses inline transition
	document.querySelectorAll('section[data-section="listType2"] [data-list-type-2-toggle]').forEach((btn) => {
		const panelId = btn.getAttribute('aria-controls');
		const panel = panelId ? document.getElementById(panelId) : null;
		if (!panel) return;
		btn.addEventListener('click', function onReadMoreClick() {
			const inner = panel.querySelector('.list-type-2__collapsible-inner');
			if (!inner) return;
			btn.removeEventListener('click', onReadMoreClick);
			btn.setAttribute('aria-expanded', 'true');
			panel.setAttribute('aria-hidden', 'false');
			panel.classList.add('is-open');

			const finish = () => {
				panel.style.maxHeight = 'none';
				panel.style.overflow = '';
				panel.getAnimations?.().forEach((a) => a.cancel());
				btn.remove();
			};

			const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
			if (reduced) {
				finish();
				return;
			}

			const runExpand = () => {
				const h = Math.max(inner.scrollHeight, 1);
				panel.style.overflow = 'hidden';
				panel.style.maxHeight = '0px';

				if (typeof panel.animate === 'function') {
					const anim = panel.animate(
						[{ maxHeight: '0px' }, { maxHeight: `${h}px` }],
						{ duration: 550, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
					);
					let settled = false;
					const done = () => {
						if (settled) return;
						settled = true;
						window.clearTimeout(failSafe);
						anim.cancel();
						finish();
					};
					anim.onfinish = done;
					const failSafe = window.setTimeout(done, 700);
					return;
				}

				panel.style.transition = 'max-height 0.55s cubic-bezier(0.4, 0, 0.2, 1)';
				requestAnimationFrame(() => {
					requestAnimationFrame(() => {
						panel.style.maxHeight = `${h}px`;
					});
				});
				const onEnd = (e) => {
					if (e.target !== panel || e.propertyName !== 'max-height') return;
					panel.removeEventListener('transitionend', onEnd);
					panel.style.transition = '';
					finish();
				};
				panel.addEventListener('transitionend', onEnd);
				window.setTimeout(() => {
					if (!btn.isConnected) return;
					panel.removeEventListener('transitionend', onEnd);
					panel.style.transition = '';
					finish();
				}, 650);
			};

			requestAnimationFrame(() => requestAnimationFrame(runExpand));
		});
	});

	// Cashflow / Capital Growth: pill toggles only ≤1023px; desktop shows full calculator always
	(function initCalculatorCollapsibles() {
		const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		const calcCollapseMq = window.matchMedia('(max-width: 1023px)');
		const isCalcMobile = () => calcCollapseMq.matches;

		function syncCalculatorCollapseAria() {
			document.querySelectorAll('[data-calculator-panel]').forEach((panel) => {
				const id = panel.id;
				const btn = id ? document.querySelector(`[data-calculator-toggle][aria-controls="${id}"]`) : null;
				if (!isCalcMobile()) {
					panel.setAttribute('aria-hidden', 'false');
					if (btn) btn.setAttribute('aria-expanded', 'true');
					panel.getAnimations?.().forEach((a) => a.cancel());
					panel.style.maxHeight = '';
					panel.style.opacity = '';
					panel.style.overflow = '';
					panel.style.transition = '';
					return;
				}
				const expanded = panel.classList.contains('is-expanded');
				panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
				if (btn) btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
			});
		}

		if (typeof calcCollapseMq.addEventListener === 'function') {
			calcCollapseMq.addEventListener('change', syncCalculatorCollapseAria);
		} else if (typeof calcCollapseMq.addListener === 'function') {
			calcCollapseMq.addListener(syncCalculatorCollapseAria);
		}
		syncCalculatorCollapseAria();

		document.querySelectorAll('[data-calculator-toggle]').forEach((btn) => {
			const panelId = btn.getAttribute('aria-controls');
			const panel = panelId ? document.getElementById(panelId) : null;
			if (!panel) return;

			const openPanel = () => {
				if (!isCalcMobile()) return;
				btn.setAttribute('aria-expanded', 'true');
				panel.setAttribute('aria-hidden', 'false');
				panel.getAnimations?.().forEach((a) => a.cancel());

				if (reducedMotion()) {
					panel.classList.add('is-expanded');
					return;
				}

				const runOpen = () => {
					const h = Math.max(panel.scrollHeight, 1);
					panel.style.overflow = 'hidden';

					if (typeof panel.animate === 'function') {
						panel.style.maxHeight = '0px';
						const anim = panel.animate(
							[
								{ maxHeight: '0px', opacity: 0 },
								{ maxHeight: `${h}px`, opacity: 1 },
							],
							{ duration: 500, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
						);
						let settled = false;
						const doneOpen = () => {
							if (settled) return;
							settled = true;
							window.clearTimeout(failOpen);
							anim.cancel();
							panel.classList.add('is-expanded');
							panel.style.maxHeight = '';
							panel.style.opacity = '';
							panel.style.overflow = '';
						};
						anim.onfinish = doneOpen;
						const failOpen = window.setTimeout(doneOpen, 650);
						return;
					}

					panel.style.transition = 'max-height 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.35s ease-out';
					panel.style.maxHeight = '0px';
					panel.style.opacity = '0';
					requestAnimationFrame(() => {
						requestAnimationFrame(() => {
							panel.style.maxHeight = `${h}px`;
							panel.style.opacity = '1';
						});
					});
					const onEnd = (e) => {
						if (e.target !== panel || e.propertyName !== 'max-height') return;
						panel.removeEventListener('transitionend', onEnd);
						panel.classList.add('is-expanded');
						panel.style.maxHeight = '';
						panel.style.transition = '';
						panel.style.opacity = '';
					};
					panel.addEventListener('transitionend', onEnd);
					window.setTimeout(() => {
						panel.removeEventListener('transitionend', onEnd);
						panel.classList.add('is-expanded');
						panel.style.maxHeight = '';
						panel.style.transition = '';
						panel.style.opacity = '';
					}, 600);
				};

				requestAnimationFrame(() => requestAnimationFrame(runOpen));
			};

			const closePanel = () => {
				if (!isCalcMobile()) return;
				btn.setAttribute('aria-expanded', 'false');
				panel.setAttribute('aria-hidden', 'true');
				panel.getAnimations?.().forEach((a) => a.cancel());

				if (reducedMotion()) {
					panel.classList.remove('is-expanded');
					return;
				}

				const h = Math.max(panel.scrollHeight, 1);
				panel.style.maxHeight = `${h}px`;
				panel.style.opacity = '1';
				panel.classList.remove('is-expanded');
				void panel.offsetHeight;
				panel.style.overflow = 'hidden';

				if (typeof panel.animate === 'function') {
					const anim = panel.animate(
						[
							{ maxHeight: `${h}px`, opacity: 1 },
							{ maxHeight: '0px', opacity: 0 },
						],
						{ duration: 450, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
					);
					let settledClose = false;
					const doneClose = () => {
						if (settledClose) return;
						settledClose = true;
						window.clearTimeout(failClose);
						anim.cancel();
						panel.style.maxHeight = '';
						panel.style.opacity = '';
						panel.style.overflow = '';
					};
					anim.onfinish = doneClose;
					const failClose = window.setTimeout(doneClose, 550);
					return;
				}

				panel.style.transition = 'max-height 0.45s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease-out';
				panel.style.maxHeight = '0px';
				panel.style.opacity = '0';
				const onEnd = (e) => {
					if (e.target !== panel || e.propertyName !== 'max-height') return;
					panel.removeEventListener('transitionend', onEnd);
					panel.style.maxHeight = '';
					panel.style.transition = '';
					panel.style.opacity = '';
					panel.style.overflow = '';
				};
				panel.addEventListener('transitionend', onEnd);
				window.setTimeout(() => {
					panel.removeEventListener('transitionend', onEnd);
					panel.style.maxHeight = '';
					panel.style.transition = '';
					panel.style.opacity = '';
					panel.style.overflow = '';
				}, 500);
			};

			btn.addEventListener('click', () => {
				if (!isCalcMobile()) return;
				const expanded = btn.getAttribute('aria-expanded') === 'true';
				if (expanded) closePanel();
				else openPanel();
			});
		});
	})();

});

/////////////////////




// RESIZE

$(window).on('resize', function() {
	checkLogoColor();
});

////////////////////




// FORMS

$(function () {
	var forms = $('[data-freeform]');
	if (forms.length) {
		forms.each(function() {
			var formEl = $(this);
			initFormButton(formEl);
			formEl.on('freeform-ajax-success', function (event) {
				setTimeout(function() {
					initFormButton(formEl);
				}, 10);
			});
			formEl.on('freeform-ajax-error', function (event) {
				setTimeout(function() {
					initFormButton(formEl);
				}, 10);
			});
		})
	}

	// CTA Type 3 (linkType): modal (fade/slide) + downloads after Freeform success
	function parseCtaType3DownloadUrls(raw) {
		if (!raw || typeof raw !== 'string') return [];
		try {
			var urls = JSON.parse(raw);
			return Array.isArray(urls) ? urls.filter(Boolean) : [];
		} catch (_) {
			return [];
		}
	}

	function openAssetUrlFallback(url) {
		var a = document.createElement('a');
		a.href = url;
		a.target = '_blank';
		a.rel = 'noopener noreferrer';
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}

	function downloadUrlAsFile(url, filenameHint) {
		var name =
			filenameHint ||
			(String(url).split('/').pop() || 'download').split('?')[0] ||
			'download';
		try {
			var abs = new URL(url, window.location.href);
			if (abs.origin === window.location.origin) {
				return fetch(String(url), { credentials: 'same-origin' })
					.then(function (res) {
						if (!res.ok) throw new Error('fetch failed');
						return res.blob();
					})
					.then(function (blob) {
						var objectUrl = URL.createObjectURL(blob);
						var a = document.createElement('a');
						a.href = objectUrl;
						a.download = name;
						a.rel = 'noopener noreferrer';
						document.body.appendChild(a);
						a.click();
						document.body.removeChild(a);
						window.setTimeout(function () {
							URL.revokeObjectURL(objectUrl);
						}, 2500);
					})
					.catch(function () {
						openAssetUrlFallback(url);
					});
			}
		} catch (_) {
			// fall through to cross-origin / invalid URL
		}
		openAssetUrlFallback(url);
		return Promise.resolve();
	}

	function triggerCtaType3Downloads(urls) {
		if (!urls.length) return;
		urls.forEach(function (url, i) {
			window.setTimeout(function () {
				downloadUrlAsFile(url);
			}, i * 450);
		});
	}

	function focusCtaType3TriggerAfterClose(modal) {
		var modalId = modal && modal.id;
		var openBtn = null;
		if (modalId) {
			var idForSel =
				typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
					? CSS.escape(modalId)
					: modalId;
			openBtn = document.querySelector(
				'[data-cta-type-3-open][aria-controls="' + idForSel + '"]'
			);
		}
		if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
		if (typeof lenis !== 'undefined' && lenis && typeof lenis.start === 'function') {
			lenis.start();
		}
		if (openBtn) openBtn.focus();
	}

	function hardCloseCtaType3Modal(modal) {
		if (!modal || !modal.getAttribute) return;
		modal.classList.remove('cta-type-3-modal--open');
		modal.removeAttribute('inert');
		modal.setAttribute('hidden', '');
		modal.setAttribute('aria-hidden', 'true');
	}

	function closeCtaType3Modal(modal) {
		if (!modal || !modal.getAttribute) return;
		var reduced =
			window.matchMedia &&
			window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		if (!modal.classList.contains('cta-type-3-modal--open')) {
			hardCloseCtaType3Modal(modal);
			focusCtaType3TriggerAfterClose(modal);
			return;
		}
		modal.setAttribute('aria-hidden', 'true');
		modal.setAttribute('inert', '');
		modal.classList.remove('cta-type-3-modal--open');
		if (reduced) {
			hardCloseCtaType3Modal(modal);
			focusCtaType3TriggerAfterClose(modal);
			return;
		}
		var settled = false;
		function done() {
			if (settled) return;
			settled = true;
			window.clearTimeout(failSafe);
			modal.removeEventListener('transitionend', onEnd);
			hardCloseCtaType3Modal(modal);
			focusCtaType3TriggerAfterClose(modal);
		}
		function onEnd(ev) {
			if (ev.target !== modal || ev.propertyName !== 'opacity') return;
			done();
		}
		// Dialog transform is 0.35s; overlay opacity 0.3s — allow slightly longer for both to settle
		var failSafe = window.setTimeout(done, 480);
		modal.addEventListener('transitionend', onEnd);
	}

	function openCtaType3Modal(modal, triggerBtn) {
		if (!modal || !modal.getAttribute) return;
		var reduced =
			window.matchMedia &&
			window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		modal.classList.remove('cta-type-3-modal--open');
		modal.removeAttribute('hidden');
		// Block interaction until visible; aria follows --open (avoids AT seeing an "empty" dialog)
		modal.setAttribute('inert', '');
		modal.setAttribute('aria-hidden', 'true');
		if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'true');
		if (typeof lenis !== 'undefined' && lenis && typeof lenis.stop === 'function') {
			lenis.stop();
		}
		if (reduced) {
			modal.removeAttribute('inert');
			modal.setAttribute('aria-hidden', 'false');
			modal.classList.add('cta-type-3-modal--open');
		} else {
			void modal.offsetHeight;
			window.requestAnimationFrame(function () {
				window.requestAnimationFrame(function () {
					modal.removeAttribute('inert');
					modal.setAttribute('aria-hidden', 'false');
					modal.classList.add('cta-type-3-modal--open');
				});
			});
		}
		var dlForm = getCtaType3DownloadForm(modal);
		if (dlForm) {
			stripFreeformMessages(dlForm);
			initFormButton($(dlForm));
		}
		var focusTarget =
			modal.querySelector(
				'.cta-type-3-modal__body input, .cta-type-3-modal__body select, .cta-type-3-modal__body textarea'
			) ||
			modal.querySelector(
				'[data-freeform] input, [data-freeform] select, [data-freeform] textarea'
			) ||
			modal.querySelector('[data-cta-type-3-modal-close]');
		if (focusTarget) focusTarget.focus();
	}

	function getFreeformEventForm(e) {
		if (!e) return null;
		if (e.form) return e.form;
		var d = e.detail;
		if (d && d.form) return d.form;
		var t = e.target;
		if (t && t.tagName === 'FORM') return t;
		if (t && typeof t.closest === 'function') {
			var inForm = t.closest('form');
			if (inForm) return inForm;
		}
		return null;
	}

	function getFreeformEventResponse(e) {
		if (!e) return null;
		if (e.response !== undefined && e.response !== null) return e.response;
		var d = e.detail;
		if (d && d.response !== undefined) return d.response;
		return null;
	}

	function findCtaType3ModalFromFreeformEvent(e) {
		var form = getFreeformEventForm(e);
		if (form && typeof form.closest === 'function') {
			var fromForm = form.closest('[data-cta-type-3-modal]');
			if (fromForm && fromForm.hasAttribute('data-cta-type-3-modal')) return fromForm;
		}
		var t = e && e.target;
		if (!t || !t.closest) return null;
		var body = t.closest('[data-cta-type-3-modal-root]');
		if (body) {
			var rid = body.getAttribute('data-cta-type-3-modal-root');
			if (rid) {
				var byId = document.getElementById(rid);
				if (byId && byId.hasAttribute('data-cta-type-3-modal')) return byId;
			}
		}
		var m = t.closest('[data-cta-type-3-modal]');
		return m || null;
	}

	function getCtaType3DownloadForm(modal) {
		if (!modal || !modal.querySelector) return null;
		return modal.querySelector('form[data-freeform="downloadInvestorGuideForm"]');
	}

	function stripFreeformMessages(form) {
		if (!form || !form.querySelectorAll) return;
		form.querySelectorAll('.freeform-form-success, .freeform-form-errors').forEach(
			function (el) {
				el.remove();
			}
		);
		form.querySelectorAll('.freeform-errors').forEach(function (el) {
			el.remove();
		});
		form.querySelectorAll('[class*="freeform-has-errors"]').forEach(function (el) {
			el.classList.remove('freeform-has-errors');
		});
	}

	function applyFreeformHoneypotFromResponse(form, response) {
		var hp = response && response.honeypot;
		if (!hp || !form) return;
		var input =
			form.querySelector('input[name^="freeform_form_handle_"]') ||
			form.querySelector('input[name*="freeform_form_handle"]');
		if (!input) return;
		if (hp.name) {
			input.setAttribute('name', hp.name);
			input.setAttribute('id', hp.name);
		}
		if (hp.hash !== undefined && hp.hash !== null) {
			input.value = hp.hash;
		}
	}

	function resetCtaType3DownloadForm(form, response) {
		if (!form) return;
		applyFreeformHoneypotFromResponse(form, response);
		stripFreeformMessages(form);
		try {
			if (typeof form.reset === 'function') form.reset();
		} catch (_) {}
		initFormButton($(form));
	}

	function isCtaType3DownloadFormElement(form) {
		return (
			form &&
			form.getAttribute &&
			form.getAttribute('data-freeform') === 'downloadInvestorGuideForm' &&
			form.closest('[data-cta-type-3-modal]')
		);
	}

	// Block default success banner for modal download form; we reset and close instead.
	document.addEventListener(
		'freeform-render-success',
		function (ev) {
			var form = getFreeformEventForm(ev);
			if (!isCtaType3DownloadFormElement(form)) return;
			ev.preventDefault();
		},
		true
	);

	// Native listener: Freeform dispatches on document and on the form (see Freeform 5 AJAX docs).
	function onCtaType3FreeformAjaxSuccess(ev) {
		var resp = getFreeformEventResponse(ev);
		if (resp && resp.success === false) return;
		// Multipage: only act on final page (docs use response.finished for redirects).
		if (resp && resp.finished === false) return;
		var form = getFreeformEventForm(ev);
		var modal = findCtaType3ModalFromFreeformEvent(ev);
		if (!modal) {
			modal = document.querySelector(
				'[data-cta-type-3-modal].cta-type-3-modal--open'
			);
		}
		if (!modal) return;
		if (!form) form = getCtaType3DownloadForm(modal);
		if (form && isCtaType3DownloadFormElement(form)) {
			resetCtaType3DownloadForm(form, resp);
			window.setTimeout(function () {
				if (form && form.isConnected && isCtaType3DownloadFormElement(form)) {
					stripFreeformMessages(form);
					initFormButton($(form));
				}
			}, 0);
		}
		var raw = modal.getAttribute('data-download-urls');
		var urls = parseCtaType3DownloadUrls(raw);
		triggerCtaType3Downloads(urls);
		window.setTimeout(function () {
			closeCtaType3Modal(modal);
		}, 200);
	}
	document.addEventListener('freeform-ajax-success', onCtaType3FreeformAjaxSuccess);

	$(document).on('click', '[data-cta-type-3-open]', function (e) {
		e.preventDefault();
		var btn = this;
		var section = btn.closest('section[data-section="ctaType3"]');
		if (!section) return;
		var controlsId = btn.getAttribute('aria-controls');
		if (!controlsId) return;
		var modal = document.getElementById(controlsId);
		if (!modal || !modal.hasAttribute('data-cta-type-3-modal')) return;
		openCtaType3Modal(modal, btn);
	});

	$(document).on('click', '[data-cta-type-3-modal-close]', function (e) {
		e.preventDefault();
		var modal = e.target.closest('[data-cta-type-3-modal]');
		closeCtaType3Modal(modal);
	});

	$(document).on('keydown', function (e) {
		if (e.key !== 'Escape') return;
		var openModal = document.querySelector(
			'[data-cta-type-3-modal].cta-type-3-modal--open'
		);
		if (!openModal) return;
		e.preventDefault();
		closeCtaType3Modal(openModal);
	});

    $('textarea').on('input', function () {
        $(this).css('height', 'auto'); // Reset height to calculate new scroll height
        $(this).css('height', this.scrollHeight + 'px'); // Set height to match the content
    });
});

function initFormButton(formEl) {
	var btn = formEl.find('button.freeform-button-submit');
	var btnText = btn.text();
	if (btnText) {
		var newText = '<span>' + btnText + '</span><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g transform="translate(-425 5)"><rect width="40" height="40" rx="20" transform="translate(425 -5)" opacity="0"></rect><path d="M1.78,0,7.216,5.436,1.78,10.872M-8.784,5.436H6.591" transform="translate(441.71 10.538) rotate(-45)" fill="none" stroke="currentColor" stroke-width="2"></path></g></svg>';
		btn.html(newText);
	}
}

///////////////////////////////////////




// sliderType1

$(document).ready(function() {
    let triggers = $('[data-section="sliderType1"] [data-trigger]');
    let interval;

    function startInterval() {
        interval = setInterval(function() {
            // Find the current "revealed" trigger and start from the next one
            let currentIndex = triggers.index($('[data-section="sliderType1"] [data-trigger][data-revealed="true"]'));
            let nextIndex = (currentIndex + 1) % triggers.length;

            $(triggers[nextIndex]).trigger('click'); // Trigger click on the next block
        }, 7000);
    }

    function resetInterval() {
		if ($(window).width() >= 1280) {
			clearInterval(interval);
			startInterval();
		}
    }

    if ($(window).width() >= 1280) {
    	startInterval();
	}

	$(document).on('click', '[data-section="sliderType1"] [data-trigger]', function(e) {
		var section = $(this).closest('section');
		var othersTrigger = section.find('[data-trigger]');
		var othersContent = section.find('[data-trigger-content]');
		var othersImage = section.find('[data-trigger-image]');
		var revealed = $(this).attr('data-revealed');
		var uid = $(this).attr('data-trigger');
		var content = section.find('[data-trigger-content="' + uid + '"]');
		var image = section.find('[data-trigger-image="' + uid + '"]');
		if (revealed == 'false') {
			othersTrigger.attr('data-revealed','false');
			othersContent.slideUp(300);
			othersImage.attr('data-revealed','false');
			content.slideDown(300);
			$(this).attr('data-revealed','true');
			image.attr('data-revealed','true');
		}
	});

    // Pause on hover
    $(document).on('mouseenter', '[data-section="sliderType1"] [data-trigger]', function() {
        clearInterval(interval); // Pause
    }).on('mouseleave', '[data-section="sliderType1"] [data-trigger]', function() {
        resetInterval(); // Resume when hover ends
    });
});

///////////////////////////////////////




// LIST TYPE 1

$(document).on('click', '[data-section="listType1"] .list-heading', function(e) {
	var revealed = $(this).attr('data-revealed');
	if (revealed == 'false') {
		$(this).find('.link').text('Less');
		$(this).attr('data-revealed','true');
		$(this).parent().find('.list-content').slideDown(300);
	} else {
		$(this).find('.link').text('More');
		$(this).attr('data-revealed','false');
		$(this).parent().find('.list-content').slideUp(300);
	}
});

////////////////////




// FILTER - NEWS

let currentPage_N = 1;
let loading_N = false;
let currentCategory_N = 'all';
let cardsEl_N = $('section[data-section="filterNews"] .column-cards');
let loadMoreEl_N = $('section[data-section="filterNews"] [data-load-more]');

// Handle category filter click
$(document).on('click', 'section[data-section="filterNews"] [data-filter-trigger="category"]', function (e) {
    e.preventDefault();
    currentCategory_N = $(this).attr('data-filter-value');
    currentPage_N = 1;
    $('[data-filter-trigger="category"]').removeClass('active');
    $(this).addClass('active');
    cardsEl_N.empty();
	// console.log('currentPage_N ' + currentPage_N)
	// console.log('currentCategory_N ' + currentCategory_N)
    loadMoreNews(currentPage_N, currentCategory_N);

	//update url
	var currentUrl = window.location.href;
	currentUrl = decodeURIComponent(currentUrl);
	var url = new URL(currentUrl);
	url.searchParams.set('category', currentCategory_N);
	window.history.replaceState({}, document.title, url.toString());
});

function newsShowAll() {
	if (!$('[data-section="filterNews"]').length) 
		return null;

	var $sec = $('[data-section="filterNews"]');
	var $cardsRow = $sec.find('.row-cards');
	var $cards = $sec.find('.block-cta');

	if ($cards.length < 15)
		return null;

	$cards.slice(15).hide();

	// init btn
	var $btn = null;
	if ($sec.find('[data-load-more]').length) {
		$btn = $sec.find('[data-load-more]');
		$btn.fadeIn(200);
	} else  {
		$sec.find('.container').append(`<div class="row">
					<div class="column column-more">
						<button type="button" data-load-more>Show All</button>
					</div>
				</div>`);
		$btn = $sec.find('[data-load-more]');
	}
	
	$btn.click(function(e) {
		e.preventDefault();
		$cards.filter(':hidden').stop().fadeIn(400);
		$(this).fadeOut(200);
	})
}

$(document).ready(function(){
	newsShowAll();	
});


const newsFilterSection = $('section[data-section="filterNews"]');

$(function() {
	if (newsFilterSection.length) {
		var filter = getUrlParameter('category');
		var filterButton = newsFilterSection.find('[data-filter-value="' + filter + '"]');
		if (filterButton.length) {
			filterButton.trigger('click')
			
		}
	}
});

async function loadMoreNews(page, category = 'all') {
    try {
        const response = await $.ajax({
            type: 'get',
            url: `/news.json?page=${page}&category=${category}`,
        });
		let events = response.data;
        let limit = 8;
        if (events.length > 0) {
            events.forEach(function (event) {
                cardsEl_N.append(event.html);
				limit = event.limit;
            });
			newsShowAll();
			loading_N = false; // Allow loading more pages
        }
		// console.log('limit ' + limit)
		// console.log('events.length ' + events.length)
		if (events.length < limit || events.length == 0) {
            loadMoreEl_N.attr('data-load-more','false');
		} else {
            loadMoreEl_N.attr('data-load-more','true');
		}

    } catch (error) {
        console.log('Error loading more events:', error);
    }
}

////////////////////




// MENU MOBILE

$(document).on('click', '[data-menu-trigger]', function(e) {
	var revealed = $(this).attr('data-menu-revealed');
	if (revealed == 'false') {
		$(this).text('Close');
		$(this).attr('data-menu-revealed','true');
		$('body').attr('data-menu-revealed','true');
		$('aside.main-menu').attr('data-menu-revealed','true');
		$('aside.main-menu').attr('data-container-revealed','true');
		lenis.stop();
	} else {
		$(this).text('Menu');
		$(this).attr('data-menu-revealed','false');
		$('body').attr('data-menu-revealed','false');
		$('aside.main-menu').attr('data-menu-revealed','false');
		setTimeout(() => {
			$('aside.main-menu').attr('data-container-revealed','false');
		}, 1000);
		lenis.start();
	}
});

////////////////////




// HELPERS

window.getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};  

function fadeUp($el, duration = 200) {
	$el.stop(true, true).css({
		opacity: 0,
		transform: 'translateY(10px)',
		display: 'flex'
	}).animate({
		opacity: 1
	}, {
		duration: duration,
		step: function (now, fx) {
			if (fx.prop === 'opacity') {
				$el.css('transform', `translateY(${(1 - now) * 10}px)`);
			}
		}
	});
}

function fadeDown($el, duration = 200) {
	$el.stop(true, true).animate({
		opacity: 0
	}, {
		duration: duration,
		step: function (now, fx) {
			if (fx.prop === 'opacity') {
				$el.css('transform', `translateY(${(1 - now) * 10}px)`);
			}
		},
		complete: function () {
			$el.css({ display: 'none' });
		}
	});
}

///////////////////////////////////////




// SECTION GALLERY POPUP

$(document).on('click', '[data-reveal-gallery]', function(e) {
	var aside = $('[data-gallery]');
	if (aside.length) {
		aside.attr('data-revealed', 'true');
	}
	var newHash = $(this).attr('data-reveal-gallery');
	if (newHash) {
		setTimeout(() => {
			window.location.hash = newHash;
		}, 150);
	}
});

$(document).on('click', '[data-hide-gallery]', function(e) {
	var aside = $('[data-gallery]');
	if (aside.length) {
		aside.attr('data-revealed', 'false');
	}
});

////////////////////////////////////////


$(document).on('click', '[data-popup-trigger]', function(e) {
	header.removeClass('nav-up nav-down');
	setTimeout(() => {
		header.removeClass('nav-up nav-down');
	}, 500);
	$('body').attr('data-menu-revealed','true');
	if ($('aside.main-menu').attr('data-menu-revealed') == 'true') {
		$('[data-menu-trigger]').trigger('click')
	}


	$('body').attr('data-menu-revealed','false');
	$('aside[data-popup]').attr('data-popup-revealed','false');
	$('[data-popup-trigger]').attr('data-popup-revealed','false');
	$('aside[data-popup]').attr('data-container-revealed','false');


	var uid = $(this).attr('data-popup-trigger');
	$(this).attr('data-popup-revealed','true');
	$('aside[data-popup="' + uid + '"]').attr('data-popup-revealed','true');
	$('aside[data-popup="' + uid + '"]').attr('data-container-revealed','true');
	if ($(window).scrollTop() <= navbarHeight) {
		$('aside[data-popup="' + uid + '"]').attr('data-offset','true');
	} else {
		$('aside[data-popup="' + uid + '"]').attr('data-offset','false');
	}
	lenis.stop();
});

$(document).on('click', '[data-trigger-popup-close]', function(e) {
	header.removeClass('nav-up nav-down');
	$('body').attr('data-menu-revealed','false');
	$('aside[data-popup]').attr('data-popup-revealed','false');
	$('[data-popup-trigger]').attr('data-popup-revealed','false');
	// setTimeout(() => {
		$('aside[data-popup]').attr('data-container-revealed','false');
	// }, 1000);
	lenis.start();
});


/**
 *  HEADER LOGO CHANGE COLOR
 */

if ($('header .column-logo svg').length) {

	var darkSections = [
		'light',  
		'primary-three', 
		'primary-four',
		'primary-five',
		'primary-six',
		'secondary-four',
		'primary-nine',
		'primary-eight',
		'primary-one',
	];
	var lightSections = [
		'primary-two',
		'primary-seven',
	];

	if ($('[data-section').length) {
		checkLogoColor();
	}
}

function checkLogoColor() {
	var pos = $(window).scrollTop();

	$('section[data-section][data-bg]').each(function() {
		var $sec = $(this);
		var secTop = $sec.offset().top;
		var secBot = secTop + $sec.outerHeight();

		if (pos >= secTop && pos <= secBot) {
			//form type 1 white bg mob
			if ($sec.data('section') == 'formType1' && $(window).width() < 1024) {
				$('.headerContainer').attr('data-bg','primary-two')
				return false
			}

			var secBg = $sec.data('bg') ? $sec.data('bg') : 'light';

			// Residences: primary-one is dark forest green — needs light header
			if ($('body').hasClass('theme-residences') && secBg === 'primary-one') {
				$('.headerContainer').attr('data-bg', 'primary-nine');
				return false;
			}

			if (lightSections.includes(secBg)) {
				$('.headerContainer').attr('data-bg','primary-nine')

				//text type 4
				if ($sec.data('section') == 'textType4' && $(window).width() > 1023)
					$('.headerContainer').addClass('texttype4');
				else
					$('.headerContainer').removeClass('texttype4');
			}
			else if (darkSections.includes(secBg)) {
				$('.headerContainer').attr('data-bg','primary-two')
			}
			
			return false;
		}
	});
}

/**
 * PEOPLE CARDS - Show all
 */

$('[data-section="cardsType1"]').each(function() {
        var $sec = $(this);
        var $cardsRow = $sec.find('.row-cards');
        var $cards = $sec.find('.block-cta[data-popup-trigger]');

        if (!$sec.hasClass('has-more') || $cards.length <= 8) {
            return;
        }
        
        // Function to calculate and set heights
        function updateHeights() {
            // Always update the natural height
            var naturalHeight = $cardsRow[0].scrollHeight;
            $sec.data('natural-height', naturalHeight);
            
            if ($sec.hasClass('show-all')) {
                // If showing all, set to current natural height (maintains animation capability)
                $cardsRow.css('max-height', `${naturalHeight}px`);
            } else {
                // Only apply fade height when collapsed
                if (!$cards[4] || !$cardsRow.length) {
                    return;
                }
                var heightFade = ($($cards[4]).offset().top + $($cards[4]).outerHeight()) - $cardsRow.offset().top + 400;
                $cardsRow.css('max-height', `${heightFade}px`);
            }
        }
        
        // Initial setup
        updateHeights();
        
        // Bind resize event (with debouncing for performance)
        var resizeTimeout;
        $(window).on('resize.cardsType1', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(updateHeights, 100);
        });
        
        // Bind btn event
        var $btn = $sec.find('[data-load-more]');
        $btn.click(function() {
            $sec.addClass('show-all');
            var naturalHeight = $sec.data('natural-height');
            $cardsRow.css('max-height', `${naturalHeight}px`);
            $(this).fadeOut(400);
        });
    });


/**
 * TEXT TYPE 5 STICKY on mobile
 */
$(document).ready(handleStickyWrapping);
$(window).resize(debounce(handleStickyWrapping, 250));

function handleStickyWrapping() {
	var $tt4 = $('section[data-section="textType4"]');
	var $tt5 = $('section[data-section="textType5"]');

	if ($tt4.next('section[data-section="textType5"]').length > 0) {
		if ($(window).width() < 1025) {
			if (!$tt4.parent().hasClass('t45-wrap-sticky'))
				$tt4.add($tt5).wrapAll('<div class="t45-wrap-sticky"></div>');
		} else {
			if ($tt4.parent().hasClass('t45-wrap-sticky'))
				$tt4.parent('.t45-wrap-sticky').children().unwrap();
		}
	}
}

function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

///////////////////////////////////////

// FORM TYPE 1 - Toggle + Location Selector

(function initFormType4() {
	document.querySelectorAll('section[data-section="formType4"]').forEach(function(section) {
		var toggle = section.querySelector('.form-toggle');
		var toggleBtns = section.querySelectorAll('[data-toggle-btn]');
		var formPanels = section.querySelectorAll('[data-form-panel]');
		if (!formPanels.length) return;

		var activePanel = section.getAttribute('data-active-panel') || formPanels[0].getAttribute('data-form-panel');

		function setPreferredInputValue(panelKey, locationName) {
			section.querySelectorAll('[data-form-panel]').forEach(function(panel) {
				if (panel.getAttribute('data-form-panel') !== panelKey) return;
				panel.querySelectorAll('input[name*="preferred"]').forEach(function(input) {
					input.value = locationName;
				});
			});
		}

		function setLocationTeam(panelKey, locationUid) {
			section.querySelectorAll('[data-panel-default-team]').forEach(function(panel) {
				if (panel.getAttribute('data-panel-default-team') !== panelKey) return;
				panel.hidden = !!locationUid;
			});
			section.querySelectorAll('[data-location-team]').forEach(function(panel) {
				if (panel.getAttribute('data-location-panel') !== panelKey) return;
				panel.hidden = panel.getAttribute('data-location-team') !== locationUid;
			});
		}

		function setTriggerSelectedLabel(trigger, locationName) {
			if (!trigger) return;
			var selectedLabel = trigger.querySelector('[data-location-selected-label]');
			if (!selectedLabel) return;
			var hasName = !!locationName;
			var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
			selectedLabel.textContent = hasName ? locationName : '';
			selectedLabel.hidden = !hasName || isExpanded;
		}

		function setLocationError(selector, trigger) {
			if (!selector || !trigger) return;
			selector.classList.add('is-invalid');
			trigger.setAttribute('aria-invalid', 'true');
			var error = selector.querySelector('[data-location-error]');
			if (error) error.hidden = false;
		}

		function clearLocationError(selector, trigger) {
			if (!selector || !trigger) return;
			selector.classList.remove('is-invalid');
			trigger.removeAttribute('aria-invalid');
			var error = selector.querySelector('[data-location-error]');
			if (error) error.hidden = true;
		}

		function setActivePanel(target) {
			activePanel = target;
			section.setAttribute('data-active-panel', target);

			if (toggle) toggle.setAttribute('data-active', target);

			toggleBtns.forEach(function(btn) {
				var isTarget = btn.getAttribute('data-toggle-btn') === target;
				btn.classList.toggle('is-active', isTarget);
				btn.setAttribute('aria-selected', isTarget ? 'true' : 'false');
			});

			section.querySelectorAll('[data-left-panel]').forEach(function(panel) {
				panel.hidden = panel.getAttribute('data-left-panel') !== target;
			});

			section.querySelectorAll('[data-form-panel]').forEach(function(panel) {
				panel.hidden = panel.getAttribute('data-form-panel') !== target;
			});

			section.querySelectorAll('.mobile-copy > [class*="mobile-copy--"]').forEach(function(copy) {
				copy.hidden = !copy.classList.contains('mobile-copy--' + target);
			});
		}

		toggleBtns.forEach(function(btn) {
			btn.addEventListener('click', function() {
				setActivePanel(btn.getAttribute('data-toggle-btn'));
			});
		});

		// LOCATION SELECTORS (panel-scoped)
		section.querySelectorAll('[data-location-selector]').forEach(function(selector) {
			var panelKey = selector.getAttribute('data-location-panel');
			var trigger = selector.querySelector('[data-location-trigger]');
			var dropdown = selector.querySelector('[data-location-dropdown]');
			if (!panelKey || !trigger || !dropdown) return;

			$(dropdown).hide();

			selector.querySelectorAll('[data-location-option]').forEach(function(option) {
				option.classList.remove('is-active');
			});
			trigger.setAttribute('data-selected-location', '');
			setTriggerSelectedLabel(trigger, '');
			setLocationTeam(panelKey, null);
			setPreferredInputValue(panelKey, '');
			clearLocationError(selector, trigger);

			trigger.addEventListener('click', function() {
				var isOpen = $(dropdown).is(':visible');
				trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
				setTriggerSelectedLabel(trigger, trigger.getAttribute('data-selected-location'));
				$(dropdown).stop(true, true).slideToggle(300);
			});

			selector.querySelectorAll('[data-location-option]').forEach(function(option) {
				option.addEventListener('click', function() {
					var uid = option.getAttribute('data-location-option');
					var name = option.getAttribute('data-location-name');

					selector.querySelectorAll('[data-location-option]').forEach(function(o) {
						o.classList.toggle('is-active', o === option);
					});

					trigger.setAttribute('data-selected-location', name || '');
					setLocationTeam(panelKey, uid);
					setPreferredInputValue(panelKey, name);
					clearLocationError(selector, trigger);
					if ($(dropdown).is(':visible')) {
						$(dropdown).stop(true, true).slideUp(200);
					}
					trigger.setAttribute('aria-expanded', 'false');
					setTriggerSelectedLabel(trigger, name);
				});
			});
		});

		formPanels.forEach(function(panel) {
			var form = panel.querySelector('form');
			if (!form) return;
			form.addEventListener('submit', function(event) {
				var selector = panel.querySelector('[data-location-selector]');
				if (!selector) return;
				var trigger = selector.querySelector('[data-location-trigger]');
				if (!trigger) return;
				var selectedLocation = (trigger.getAttribute('data-selected-location') || '').trim();
				if (selectedLocation) {
					clearLocationError(selector, trigger);
					return;
				}
				event.preventDefault();
				event.stopPropagation();
				if (typeof event.stopImmediatePropagation === 'function') {
					event.stopImmediatePropagation();
				}
				setLocationError(selector, trigger);
				var dropdown = selector.querySelector('[data-location-dropdown]');
				if (dropdown && $(dropdown).is(':visible')) {
					$(dropdown).stop(true, true).slideUp(200);
					trigger.setAttribute('aria-expanded', 'false');
				}
				trigger.focus({ preventScroll: true });
				trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
			});
		});

		setActivePanel(activePanel);
	});
})();

///////////////////////////////////////




// sliderType2 video bg

$(document).ready(function() {
	$('section[data-section="sliderType2"] .video-bg').each(function() {
		var $videoBg = $(this);
		var $placeholder = $videoBg.find('.placeholder-image');
		var $iframe = $videoBg.find('iframe');
		
		if ($placeholder.length && $iframe.length) {
			// hide iframe initially
			$iframe.css('opacity', '0');
			
			// youtube
			if ($iframe.hasClass('youtube-bg')) {
				console.log('YouTube iframe found, setting up load handler');
				
				$iframe.on('load', function() {
					console.log('YouTube iframe load event fired');
					setTimeout(function() {
						console.log('YouTube: Hiding placeholder and showing video');
						$placeholder.fadeOut(500, function() {
							$iframe.css('opacity', '1');
						});
					}, 1000);
				});
				
				// Fallback in case load event doesn't fire
				setTimeout(function() {
					console.log('YouTube: Fallback timeout triggered');
					$placeholder.fadeOut(500, function() {
						$iframe.css('opacity', '1');
					});
				}, 5000);
			}
			// vimeo
			else if ($iframe.hasClass('vimeo-bg')) {
				$iframe.on('load', function() {
					setTimeout(function() {
						$placeholder.fadeOut(500, function() {
							$iframe.css('opacity', '1');
						});
					}, 2000);
				});
				
				// Fallback in case load event doesn't fire
				setTimeout(function() {
					$placeholder.fadeOut(500, function() {
						$iframe.css('opacity', '1');
					});
				}, 4000);
			}
		}
	});
});